import React, { useEffect, useState } from "react";
import { FiFileText } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { useParams } from "react-router-dom";
import moment from "moment";

const CarePlanCard = ({ onExportData }) => {
  const [carePlans, setCarePlans] = useState([]);

  const { pid } = useParams();

  const fetchCarePlans = async () => {
    try {
      const payload = {
        patientId: pid,
      };

      const encryptedPayload = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.post(
        "vozo/patient/getcarePlan",
        encryptedPayload,
      );

      const decryptedData = Decrypt_Value(response.data, "vozo");

      const formatted = (Array.isArray(decryptedData) ? decryptedData : []).map(
        (item) => {
          const icdCodes = item.icd_codes ? JSON.parse(item.icd_codes) : [];

          return {
            id: item.id,
            title: item.care_plan_name || "-",
            icd:
              icdCodes.length > 0
                ? icdCodes.map((i) => i.code).join(", ")
                : "-",
            // updatedDate: item.start_date || "-",
            updatedDate: item.start_date
              ? moment(item.start_date).format("MMM DD, YYYY")
              : "-",
            status: item.status || "active",
          };
        },
      );

      /* UI → latest 3 */

      const latestPlans = formatted.sort((a, b) => b.id - a.id).slice(0, 3);

      setCarePlans(latestPlans);

      /* PARENT → FULL DATA */

      if (onExportData) {
        onExportData(
          formatted.map((item) => ({
            planName: item.title,
            icd: item.icd,
            updatedDate: item.updatedDate,
            status: item.status,
          })),
        );
      }
    } catch (error) {
      console.log("Care Plan Error", error);

      setCarePlans([]);
    }
  };

  useEffect(() => {
    fetchCarePlans();
  }, []);

  const getStatusClass = (status) => {
    switch ((status || "").toLowerCase()) {
      case "active":
        return "active-status";

      case "inactive":
        return "inactive-status";
      case "cancel":
        return "warning-status";

      case "draft":
        return "resolved-status";

      default:
        return "active-status";
    }
  };

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiFileText className="care-summary-main-icon" />

        <h3 className="care-summary-title">Care Plan</h3>
      </div>

      <div className="care-summary-body">
        {carePlans.map((item, index) => (
          <div
            key={index}
            className={`care-summary-row ${
              index !== carePlans.length - 1 ? "care-summary-border" : ""
            }`}
          >
            <div className="care-summary-content">
              <div className="care-summary-heading">{item.title}</div>

              <div className="care-summary-subtext dark-sub">
                ICD Code : {item.icd}
              </div>

              <div className="care-summary-subtext">
                Updated : {item.updatedDate}
              </div>
            </div>

            <div
              className={`care-summary-status-wrap ${getStatusClass(
                item.status,
              )}`}
            >
              <span className="care-summary-status-dot"></span>

              <span className="care-summary-status-text">
                {item.status
                  ? item.status.charAt(0).toUpperCase() +
                    item.status.slice(1).toLowerCase()
                  : "-"}
              </span>
            </div>
          </div>
        ))}

        {carePlans.length === 0 && (
          <div className="care-summary-empty">No Care Plans Added</div>
        )}
      </div>
    </div>
  );
};

export default React.memo(CarePlanCard);
